module.exports = __webpack_public_path__ + "img/home-icon-1.5d860f51.png";